import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-wizard-header',
  templateUrl: './wizard-header.component.html',
  styleUrls: ['./wizard-header.component.css']
})
export class WizardHeaderComponent implements OnInit {
  @Input()
  public title: string;

  @Input()
  public step: number;

  @Input()
  public lastStep: number;

  @Input()
  public stepNumber: number;

  @Input()
  public skipSteps: number;

  @Input()
  public editItem: object = null;

  @Input()
  public loading = false; // Indica si mostrar el spinner en el paso actual seleccionado

  @Output()
  public onSelect: EventEmitter<number> = new EventEmitter<number>();

  /**
   * Initializes the component or directive after Angular first displays the data-bound properties
   * and sets up directive or component input properties.
   * - Sets the loading state to true.
   * - Unloads the spinner after 5 seconds (enough time for the user to see the spinner).
   *
   * @param {any} args The arguments object.
   * @param {any} args.step The step number.
   * @param {any} args.lastStep The last step number.
   * @param {any} args.stepNumber The step number.
   * @param {any} args.skipSteps The number of steps to skip.
   * @param {any} args.editItem The item to edit.
   *
   * @return {void} Does not return any value.
   */
  public ngOnInit(): void {
    this.loading = true;

    // Unload the spinner after 5 seconds (enough time for the user to see the spinner).
    setTimeout(() => {
      this.loading = false;
    }, 5000);
  }

  public get isVisible() {
    return this.lastStep >= this.stepNumber || !!this.editItem;
  }

  /**
   * Handles the click event, updates the loading state, emits the calculated step number,
   * and resets the loading state after a delay.
   *
   * @return {void} No return value.
   */
  public doClick(): void {
    this.loading = true;
    const stepNumber = +(Number(this.stepNumber) + Number(this.skipSteps));
    this.onSelect.emit(stepNumber);

    // Unload this spinner to go to another step.
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
